/* @flow */
import * as React from 'react';
import Modal from 'react-modal';
import KeyboardShortcuts from 'lib/KeyboardShortcuts';
import GroupQuickSwitcher from './GroupQuickSwitcher.jsx';

type State = {
  showQuickSwitcher: boolean,
};

class GroupKeyboardListener extends React.Component<{}, State> {
  state: State = {
    showQuickSwitcher: false,
  };

  componentDidMount() {
    document.addEventListener('keydown', this.handleKeyPress);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyPress);
  }

  handleKeyPress = (event: any) => {
    if (KeyboardShortcuts.isQuickSwitch(event)) {
      event.preventDefault();
      this.setState({ showQuickSwitcher: !this.state.showQuickSwitcher });
    }
  };

  handleRequestHide = () => {
    this.setState({ showQuickSwitcher: false });
  };

  render() {
    return (
      <React.Fragment>
        <Modal isOpen={this.state.showQuickSwitcher}>
          <GroupQuickSwitcher onRequestHide={this.handleRequestHide} />
        </Modal>
      </React.Fragment>
    );
  }
}

export { GroupKeyboardListener };
export default GroupKeyboardListener;
